import { Button, CodeViewer, Divider, Flex, Typography } from "djuno-design";
import { Link } from "react-router-dom";
import { ReactComponent as DjunoDesignIcon } from "./../assets/icons/logo.svg";
import { ReactComponent as ChevronRightIcon } from "./../assets/icons/chevron-right.svg";
import { ReactComponent as NpmIcon } from "./../assets/icons/npm.svg";
import { ReactComponent as GithubIcon } from "./../assets/icons/github.svg";
import { ReactComponent as ReactIcon } from "./../assets/icons/react.svg";
import { ReactComponent as TypescriptIcon } from "./../assets/icons/typescript.svg";
import { ReactComponent as TailwindcssIcon } from "./../assets/icons/tailwindcss.svg";
import { ReactComponent as FramerMotionIcon } from "./../assets/icons/framer-motion.svg";
import {
  GithubUrl,
  installationPageUrl,
  NpmPackageUrl,
  overviewPageUrl,
} from "../urls";

const { Title, Text } = Typography;

const MainPage = () => {
  return (
    <main className="w-full min-h-screen flex justify-center items-center bg-gradient-to-t from-sky-200/70 to-sky-50 dark:from-sky-950 dark:to-[#0074E4]">
      <Flex direction="col" items="center" className=" max-w-xl">
        <Title
          level={1}
          uiType="transparent"
          className=" !text-center !bg-gradient-to-r !from-blue-600 !via-cyan-600 !to-sky-600 dark:!from-slate-200 dark:!via-cyan-200 dark:!to-sky-300 !inline-block !text-transparent !bg-clip-text"
        >
          <DjunoDesignIcon className="inline-block w-[26px] h-[26px] mr-0.5 mb-0.5 text-[#0074E4] dark:text-slate-200" />
          juno Design
        </Title>
        <Text>UI library to develop front-end projects easily</Text>
        <Text className="text-center mt-1">
          20+ free and easy-to-use components built with{" "}
          <Text strong>React</Text>, <Text strong>Typescript</Text>,{" "}
          <Text strong>TailwindCSS</Text>, and <Text strong>Framer Motion</Text>
          .
        </Text>

        <Flex items="center" justify="center" className="w-full mt-3">
          <Flex items="center" className="gap-3">
            <Typography.Link target="_blank" href={NpmPackageUrl}>
              <NpmIcon className="w-12 mt-1" />
            </Typography.Link>
            <Typography.Link target="_blank" href={GithubUrl}>
              <GithubIcon className="w-7 text-slate-900 dark:text-gray-50" />
            </Typography.Link>
          </Flex>
        </Flex>
        <Flex direction="col" className="gap-5 mt-7">
          <Flex items="center" className="gap-2">
            <Link to={overviewPageUrl} className="group">
              <Button uiType="primary">
                Browse components{" "}
                <ChevronRightIcon className="w-[12px] group-hover:scale-110 group-hover:translate-x-0.5 transition-all duration-300" />
              </Button>
            </Link>
            <Link to={installationPageUrl}>
              <Button uiType="light">Installation guide</Button>
            </Link>
          </Flex>
          <Flex direction="col" className="w-full">
            {/* <Flex items="center" justify="between" className="w-full">
              <Typography.Text size="sm">Install</Typography.Text>
              <Flex items="center" className="gap-1">
                <Typography.Link>
                  <NpmIcon className="w-8 h-4" />
                </Typography.Link>
                <Typography.Link>
                  <GithubIcon className="w-7 h-7" />
                </Typography.Link>
              </Flex>
            </Flex> */}
            <CodeViewer
              code={`npm install djuno-design`}
              copyable
              language="shell"
              theme="dark"
            />
          </Flex>
        </Flex>

        <Flex direction="col" className="w-full">
          <Divider
            uiType="dashed"
            text="built with "
            className="mb-2 !mt-8"
            textClassName="text-sm"
          />
          <Flex items="center" justify="center" className="gap-3 w-full">
            <Text
              uiType="transparent"
              className="group"
              tooltip={{ content: "React" }}
            >
              <ReactIcon className="w-6 aspect-square group-hover:rotate-90 transition-all !duration-700 dark:text-slate-200" />
            </Text>
            <Text
              uiType="transparent"
              className="group"
              tooltip={{ content: "Typescript" }}
            >
              <TypescriptIcon className="w-6 aspect-square group-hover:scale-110 transition-all duration-500 dark:text-slate-200" />
            </Text>
            <Text
              uiType="transparent"
              className="group"
              tooltip={{ content: "Tailwindcss" }}
            >
              <TailwindcssIcon className="w-6 aspect-square group-hover:scale-125 transition-all duration-500 dark:text-slate-200" />
            </Text>
            <Text
              uiType="transparent"
              className="group"
              tooltip={{ content: "Framer Motion" }}
            >
              <FramerMotionIcon className="w-6 aspect-square group-hover:scale-125 transition-all duration-500 dark:text-slate-200" />
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </main>
  );
};

export default MainPage;
